const messages = {}
const locales = require.context('./grid-kendo/', false, /grid-kendo-[\w]+\.json$/)
locales.keys().forEach(fileName => {
  const lang = fileName.replace(/^\.\/grid-kendo-([\w]+)\.json$/, '$1')
  messages[lang] = locales(fileName)
})
export default messages
